import React, { useState } from 'react';
import { Plus } from 'lucide-react';

const TaskInput = ({ onAddTask }) => {
  const [taskText, setTaskText] = useState('');

  const handleSubmit = () => {
    if (taskText.trim()) {
      onAddTask(taskText.trim());
      setTaskText('');
    }
  };

  return (
    <div className="w-full">
      <div className="flex items-center gap-2 mb-2">
        <Plus className="w-4 h-4 text-gray-400" />
        <span className="text-xs tracking-[0.2em] text-gray-400 font-mono uppercase">ADD TASK</span>
      </div>
      
      <textarea
        value={taskText}
        onChange={(e) => setTaskText(e.target.value)}
        placeholder="Enter a task..."
        data-testid="task-input-textarea"
        className="w-full h-20 px-4 py-3 bg-[#0d1520] border border-gray-700 rounded text-white font-mono placeholder-gray-500 resize-none focus:outline-none focus:border-gray-600 transition-colors"
      />
      
      <button
        onClick={handleSubmit}
        data-testid="add-task-button"
        className="w-full mt-3 px-4 py-3 bg-[#1a2535] hover:bg-[#243040] border border-gray-700 rounded text-white font-mono flex items-center justify-center gap-2 transition-colors"
      >
        <Plus className="w-4 h-4" />
        <span>Add Task</span>
      </button>
    </div>
  );
};

export default TaskInput;
